/* Buchan · gerçek fotoğrafla ıslanma efekti (kuru | ıslak foto seti) */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const M = 192; // ıslaklık haritası çözünürlüğü

  function Wet(root) {
    const wrap = root.closest('.b-wetwrap');
    const cv = root.querySelector('canvas');
    const ctx = cv.getContext('2d');
    const rows = +root.dataset.rows || 1;
    const rain = +root.dataset.rain || 1;
    const mask = document.createElement('canvas'); mask.width = mask.height = M;
    const mx = mask.getContext('2d');
    const layer = document.createElement('canvas');
    const lx = layer.getContext('2d');
    const img = new Image();
    let row = 0, prevRow = -1, fade = 1, W = 0, H = 0, S = 0, ready = false, vis = true, raf = 0, last = 0;
    let wetAmt = 0, lastPtr = null, idleT = 0, introT = 0;
    const beads = [];
    const sw = wrap.querySelectorAll('[data-row]');
    const go = wrap.querySelector('[data-b-wet-go]');
    const goName = wrap.querySelector('[data-b-wet-name]');

    const size = () => {
      const r = root.getBoundingClientRect();
      const d = Math.min(devicePixelRatio || 1, 2);
      W = cv.width = Math.round(r.width * d); H = cv.height = Math.round(r.height * d);
      layer.width = W; layer.height = H;
    };
    // soft, irregular wet blob
    const blob = (x, y, r, a) => {
      for (let i = 0; i < 5; i++) {
        const ox = x + (Math.random() - .5) * r * .9, oy = y + (Math.random() - .5) * r * .9, rr = r * (.45 + Math.random() * .6);
        const g = mx.createRadialGradient(ox, oy, 0, ox, oy, rr);
        g.addColorStop(0, `rgba(0,0,0,${a})`); g.addColorStop(.6, `rgba(0,0,0,${a * .55})`); g.addColorStop(1, 'rgba(0,0,0,0)');
        mx.fillStyle = g; mx.beginPath(); mx.arc(ox, oy, rr, 0, 7); mx.fill();
      }
      wetAmt = Math.min(1, wetAmt + a * r / 400);
    };
    const toMap = (cx, cy) => {
      const r = cv.getBoundingClientRect();
      return [(cx - r.left) / r.width * M, (cy - r.top) / r.height * M];
    };
    const drop = (x, y, big) => {
      blob(x, y, big ? 9 + Math.random() * 6 : 3 + Math.random() * 4, big ? .9 : .7);
      if (beads.length < 60) beads.push({ x: x / M, y: y / M, r: (big ? 3 : 1.6) + Math.random() * 2, life: 1, vy: Math.random() * .0006 });
    };

    // dry → wet crop from sprite
    const draw = (t) => {
      const dt = Math.min(64, t - (last || t)); last = t;
      // drying
      mx.globalCompositeOperation = 'destination-out';
      mx.fillStyle = `rgba(0,0,0,${0.0045 * dt / 16})`;
      mx.fillRect(0, 0, M, M);
      mx.globalCompositeOperation = 'source-over';
      wetAmt = Math.max(0, wetAmt - 0.0018 * dt / 16);
      // rain
      if (!RM && vis && Math.random() < 0.05 * rain * dt / 16) drop(M * (.2 + Math.random() * .6), M * (.08 + Math.random() * .85), false);
      // intro sweep so it reveals without interaction
      if (introT < 1) {
        introT += dt / 2600;
        const p = Math.min(1, introT), x = M * (.25 + .5 * p), y = M * (.25 + .45 * Math.sin(p * Math.PI));
        blob(x, y, 16, .35);
      }
      // idle auto stroke
      idleT += dt;
      if (!RM && idleT > 5000 && Math.random() < .03) { const x = M * (.3 + Math.random() * .4), y = M * (.2 + Math.random() * .6); for (let i = 0; i < 4; i++) blob(x + i * 6, y + i * 4, 12, .3); }

      const sx = img.naturalWidth / 2, sh = img.naturalHeight / rows, sz = Math.min(sx, sh);
      const cover = (srcX, r) => {
        // object-fit: cover into W×H
        const ratio = W / H; let cw = sz, ch = sz;
        if (ratio > 1) ch = sz / ratio; else cw = sz * ratio;
        return [srcX + (sz - cw) / 2, r * sh + (sz - ch) / 2, cw, ch];
      };
      ctx.globalAlpha = 1;
      const paint = (r, alpha) => {
        const [dx, dy, dw, dh] = cover(0, r);
        const [wx, wy, ww, wh] = cover(sx, r);
        ctx.globalAlpha = alpha;
        ctx.drawImage(img, dx, dy, dw, dh, 0, 0, W, H);
        lx.globalCompositeOperation = 'source-over';
        lx.clearRect(0, 0, W, H);
        lx.drawImage(img, wx, wy, ww, wh, 0, 0, W, H);
        lx.globalCompositeOperation = 'destination-in';
        lx.drawImage(mask, 0, 0, W, H);
        ctx.drawImage(layer, 0, 0);
      };
      if (fade < 1 && prevRow > -1) { paint(prevRow, 1); fade = Math.min(1, fade + dt / 420); paint(row, fade); }
      else paint(row, 1);
      ctx.globalAlpha = 1;
      // water beads with highlight
      for (let i = beads.length - 1; i >= 0; i--) {
        const b = beads[i]; b.life -= dt / 5200; b.y += b.vy * dt;
        if (b.life <= 0) { beads.splice(i, 1); continue; }
        const x = b.x * W, y = b.y * H, r = b.r * (W / 600) * (devicePixelRatio > 1 ? 1.4 : 1);
        ctx.globalAlpha = Math.min(1, b.life * 1.6) * .8;
        const g = ctx.createRadialGradient(x - r * .35, y - r * .4, r * .1, x, y, r);
        g.addColorStop(0, 'rgba(255,255,255,.85)'); g.addColorStop(.35, 'rgba(255,255,255,.18)'); g.addColorStop(1, 'rgba(0,0,0,.18)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, 7); ctx.fill();
      }
      ctx.globalAlpha = 1;
      root.classList.toggle('is-wet', wetAmt > .12);
      raf = vis ? requestAnimationFrame(draw) : 0;
    };

    const start = () => { if (!raf && ready && vis) { last = 0; raf = requestAnimationFrame(draw); } };
    root.addEventListener('pointermove', (e) => {
      idleT = 0; root.classList.add('is-touched');
      const [x, y] = toMap(e.clientX, e.clientY);
      if (lastPtr) {
        const dx = x - lastPtr[0], dy = y - lastPtr[1], n = Math.min(8, Math.ceil(Math.hypot(dx, dy) / 3));
        for (let i = 1; i <= n; i++) blob(lastPtr[0] + dx * i / n, lastPtr[1] + dy * i / n, 10, .22);
      }
      lastPtr = [x, y];
      if (Math.random() < .08) drop(x, y, false);
    });
    root.addEventListener('pointerleave', () => { lastPtr = null; });
    root.addEventListener('pointerdown', (e) => { idleT = 0; const [x, y] = toMap(e.clientX, e.clientY); drop(x, y, true); for (let i = 0; i < 5; i++) drop(x + (Math.random() - .5) * 26, y + (Math.random() - .5) * 26, false); lastPtr = [x, y]; });

    sw.forEach((b) => b.addEventListener('click', () => {
      const r = +b.dataset.row || 0; if (r === row) return;
      prevRow = row; row = r; fade = 0;
      sw.forEach((x) => x.setAttribute('aria-pressed', x === b));
      if (goName) goName.textContent = b.dataset.name;
      if (go && b.dataset.url) go.href = b.dataset.url;
      cv.setAttribute('aria-label', b.dataset.name + ' yağmurluk');
      introT = .4; // küçük bir ıslatma ile yeni rengi göster
    }));

    new ResizeObserver(size).observe(root);
    new IntersectionObserver(([en]) => { vis = en.isIntersecting; if (vis) start(); }, { rootMargin: '100px' }).observe(root);
    img.decoding = 'async';
    img.onload = () => { ready = true; root.classList.add('is-ready'); size(); start(); };
    img.src = innerWidth < 750 ? root.dataset.srcSm : root.dataset.src;
  }

  const init = (s = document) => s.querySelectorAll('[data-b-wet]:not([data-ready])').forEach((el) => { el.dataset.ready = 1; Wet(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
